import { isMobile } from "react-device-detect";
import PcCallAdvisorDetails from "./PcCallAdvisorDetails";
import PreviewControls from "./PreviewControls";

export const PcPreviewScreen = ({
  name,
  enableJoin,
  savePreferenceAndJoin,
}) => {
  const PC_BENEFITS = [
    {
      id: 1,
      img: "/profile-evaluation.webp",
      text: "Profile Evaluation & Eligibility Check",
    },
    {
      id: 2,
      img: "/deadlines.webp",
      text: "Target, Intakes & Deadlines",
    },
    {
      id: 3,
      img: "/loan-advice.webp",
      text: "Scholarship and Loan Advice",
    },
    {
      id: 4,
      img: "/application-process.webp",
      text: "Overview of Application Process",
    },
  ];

  return (
    <div className="h-screen w-screen bg-white overflow-hidden relative">
      <div className="h-screen overflow-auto pt-3 pb-28 sm:py-10 sm:px-28 sm:flex sm:flex-row sm:items-center sm:justify-center sm:gap-10">
        <div className="w-fit rounded-r-full bg-yocket-blue-600 px-3 py-1.5 text-xs font-bold text-white sm:absolute sm:top-10 sm:left-0">
          Yocket Profile Consultation
        </div>

        {/* ------------------------------- Left Part------------------------------- */}
        <div className="h-fit w-full mt-5 sm:mt-0">
          <PcCallAdvisorDetails />
        </div>

        {/* ------------------------------- Right Part------------------------------- */}
        {isMobile ? (
          <div className="mt-8 px-4 space-y-4">
            <div
              className="font-bold py-3 px-4 text-center rounded-lg w-full"
              style={{
                background:
                  "radial-gradient(135.63% 115.9% at 4.24% 97.94%, rgba(237, 224, 250, 0.40) 0%, rgba(238, 227, 231, 0.40) 48.06%, rgba(236, 245, 255, 0.40) 100%)",
              }}
            >
              Join the call to solve your doubts including but not limited to:
            </div>

            <div className="space-y-3">
              {[
                "Profile Evaluation & Eligibility Check",
                "Scholarship and Loan Advice",
                "Target, Intakes & Deadlines",
                "Overview of Application Process",
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-1">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.26701 3.45496C6.91008 3.40364 7.52057 3.15077 8.01157 2.73234C9.15738 1.75589 10.8426 1.75589 11.9884 2.73234C12.4794 3.15077 13.0899 3.40364 13.733 3.45496C15.2336 3.57471 16.4253 4.76636 16.545 6.26701C16.5964 6.91008 16.8492 7.52057 17.2677 8.01157C18.2441 9.15738 18.2441 10.8426 17.2677 11.9884C16.8492 12.4794 16.5964 13.0899 16.545 13.733C16.4253 15.2336 15.2336 16.4253 13.733 16.545C13.0899 16.5964 12.4794 16.8492 11.9884 17.2677C10.8426 18.2441 9.15738 18.2441 8.01157 17.2677C7.52057 16.8492 6.91008 16.5964 6.26701 16.545C4.76636 16.4253 3.57471 15.2336 3.45496 13.733C3.40364 13.0899 3.15077 12.4794 2.73234 11.9884C1.75589 10.8426 1.75589 9.15738 2.73234 8.01157C3.15077 7.52057 3.40364 6.91008 3.45496 6.26701C3.57471 4.76636 4.76636 3.57471 6.26701 3.45496ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z"
                      fill="#2B3340"
                    />
                  </svg>
                  <p className="text-sm">{item}</p>
                </div>
              ))}
            </div>

            <p className="text-sm font-bold">
              Also, get a chance to win free access to{" "}
              <a
                href="https://prep.yocket.com"
                className="text-[#6D28D9]"
                target="_blank"
                rel="noopener noreferrer"
              >
                GRE Prep+,
              </a>{" "}
              join the call to know more
            </p>
          </div>
        ) : (
          <div className="flex w-full flex-col justify-center ">
            <div className="space-y-6 min-h-52">
              <p className="text-xl font-bold leading-snug">
                Join the call to solve your doubts including but not limited to:
              </p>

              <div className="grid grid-cols-2 gap-x-2 gap-y-2">
                {PC_BENEFITS.map((benefit, index) => (
                  <div
                    key={`benefit-${index}`}
                    className="flex items-center gap-3 rounded-xl px-4 py-3"
                    style={{
                      background:
                        "radial-gradient(135.63% 115.9% at 4.24% 97.94%, rgba(237, 224, 250, 0.4) 0%, rgba(238, 227, 231, 0.4) 48.06%, rgba(236, 245, 255, 0.4) 100%)",
                    }}
                  >
                    <img
                      src={benefit.img}
                      alt="benefit-icon"
                      height="45"
                      width="45"
                    />
                    <p className="text-sm font-bold">{benefit.text}</p>
                  </div>
                ))}
              </div>

              <p className="text-sm font-bold">
                Also, get a chance to win free access to{" "}
                <a
                  href="https://prep.yocket.com"
                  className="text-[#6D28D9]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GRE Prep+,
                </a>{" "}
                join the call to know more
              </p>

              <div className="w-full flex gap-2.5 items-center justify-center">
                <PreviewControls
                  enableJoin={enableJoin}
                  savePreferenceAndJoin={savePreferenceAndJoin}
                  enabledColor="black"
                  settingsAsFirstOption={true}
                />
                <button
                  type="button"
                  className="yocket-btn !bg-yocket-neutral-900 !shadow-none !py-3 !text-base w-[212px] !ring-0 sm:w-full grow"
                  disabled={!name || !enableJoin}
                  onClick={savePreferenceAndJoin}
                >
                  Join the Call
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {isMobile && (
        <div className="py-3 px-4 bg-white border-t fixed bottom-0 w-full">
          <button
            type="button"
            className="yocket-btn !bg-yocket-neutral-900 !shadow-none !py-3 !text-base !ring-0 w-full !rounded-xl"
            disabled={!name || !enableJoin}
            onClick={savePreferenceAndJoin}
          >
            Join the Call
          </button>
        </div>
      )}
    </div>
  );
};

export default PcPreviewScreen;
